import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const conversationsSlice = createSlice({
  name: "conversations",
  initialState,
  reducers: {
    setConversations: (state, action) => {
      return action.payload;
    },
    conversationsAdd: (state, action) => {
      // new conversation added at the start
      const { _id, title } = action.payload;
      state.unshift({ _id, title });
    },
    conversationsClear: (state) => {
      return [];
    },
    conversationTitleUpdate: (state, action) => {
      const { _id, title } = action.payload;
      const conversation = state.find((c) => c._id === _id);
      if (conversation) {
        conversation.title = title;
      }
    },
    conversationDelete: (state, action) => {
      const { _id } = action.payload;
      return state.filter((c) => c._id !== _id);
    },
    conversationStar: (state, action) => {
      const { _id, star } = action.payload;
      const conversation = state.find((c) => c._id === _id);
      if (conversation) {
        conversation.star = star;
      }
    },
  },
});

export const {
  setConversations,
  conversationsAdd,
  conversationsClear,
  conversationTitleUpdate,
  conversationDelete,
  conversationStar,
} = conversationsSlice.actions;

export default conversationsSlice.reducer;
